/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiLeadLinkType;
(function (ApiLeadLinkType) {
    ApiLeadLinkType["LEAD_LINK_TYPE_UNSPECIFIED"] = "LeadLinkTypeUnspecified";
    ApiLeadLinkType["LEAD_LINK_TYPE_CONTACT"] = "LeadLinkTypeContact";
    ApiLeadLinkType["LEAD_LINK_PIXEL"] = "LeadLinkPixel";
})(ApiLeadLinkType || (ApiLeadLinkType = {}));
export function ApiLeadLinkTypeFromJSON(json) {
    return ApiLeadLinkTypeFromJSONTyped(json, false);
}
export function ApiLeadLinkTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiLeadLinkTypeToJSON(value) {
    return value;
}
